import { NavLink } from 'react-router-dom';
import { Activity, Calendar, LayoutGrid, ShoppingCart, Utensils } from 'lucide-react';

// Libellés entiers : le plus long (« Calories ») tient dans une piste de 75 px sur un écran
// de 375 px. Les abréviations d'origine ne réglaient rien.
export const tabs = [
  { to: '/today', label: 'Today', icon: Calendar },
  { to: '/board', label: 'Upcoming', icon: LayoutGrid },
  { to: '/courses', label: 'Courses', icon: ShoppingCart },
  { to: '/tracker', label: 'Tracker', icon: Activity },
  { to: '/calories', label: 'Calories', icon: Utensils },
] as const;

// `.barre-bas` du kit. NavLink pose `aria-current="page"` sur le lien actif : c'est l'attribut
// que le kit habille, pas une classe.
export function BottomNav(): React.ReactElement {
  return (
    <nav className="barre-bas" aria-label="Navigation principale">
      {tabs.map((tab) => (
        <NavLink key={tab.to} to={tab.to} className="barre-bas-lien">
          <tab.icon size={22} aria-hidden />
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
